import { PaginationResult } from "../../../../Shared/Model/PaginationResult";
import { Banners } from "../Model/Banners";
import { OffersPromoRepository } from "../Repository/OffersPromoRepository";

export interface GetProducstUseCase {
  invoke: (page: number, pageSize: number, search: string) => Promise<PaginationResult<Banners>>;
}

export class GetBanners implements GetProducstUseCase {
  private Repo: OffersPromoRepository;
  constructor(_Repo: OffersPromoRepository) {
    this.Repo = _Repo;
  }

   invoke(page: number, pageSize: number, search: string){
    const getData = this.Repo.getBanners(page, pageSize, search);
    return getData;
  }
}